import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromStore from '../../store';
import { Observable } from 'rxjs';
import { TreeNode, SortEvent } from 'primeng/api';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject, combineLatest} from 'rxjs';
import { EditGroupComponent } from '../edit-group/edit-group.component';
import { DeleteGroupComponent } from '../delete-group/delete-group.component';
import { isODM } from '../../../environments/environment';
import { PackageList, updateInfoType, groupStr, geteventEmitterType, SourceType } from '../../shareModel';
import { ObjectSharingParam } from '../../my-features/object-sharing/object-sharing.model';
import { TranslateService } from '@ngx-translate/core';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { PreferenceService } from '../../services/preference.service';
import { DialogComponent } from '../../../app/dialog/dialog.component';
import * as fromMyfeatures from '../../my-features';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';
import { Router } from '@angular/router';
import { RegionService } from 'src/app/services/region.service';
import { TreeTable } from 'primeng/treetable';
import { MessageService } from 'primeng/api';
import { BtyReplacementParams } from '../../my-features/battery-replacement/battery-replacement.model';
import { PlanSettingParams } from 'src/app/my-features/plan/plan-setting.model';
import { User } from '../../models/user';

@Component({
  standalone: false,
  selector: 'app-listview',
  templateUrl: './listview.component.html',
  styleUrls: ['./listview.component.css']
})
export class ListviewComponent implements OnInit, OnDestroy {
  @Input() selectedTab;
  @Input() selectedView;
  @Input() pageloading;
  @Input() keyWord;
  @Input() sortType;
  @ViewChild('tt', { static: false }) tt: TreeTable;
  stacked: boolean;
  deviceList$: Observable<any>;
  deviceGroupList$: Observable<TreeNode[]>;
  deviceGroupList = [];
  deviceGroupListStash = [];
  objectSharingParam: ObjectSharingParam = {owner_acode: 0};
  groupFeature: Boolean;
  cols: any[] = [
    { field: 'status', header: TRANSLATE('Status'), width: '80', class: 'nowrap text-center', disabled: false },
    { field: 'setting', header: '', width: '80', class: 'nowrap text-center groupSetting', disabled: true },
    { field: 'name', header: TRANSLATE('Name'), width: '200', class: 'name', disabled: true },
    { field: '', header: TRANSLATE(''), width: '180', class: '', disabled: false },
    { field: 'displaysubtype', header: TRANSLATE('Type'), width: '90', class: 'hidden-sm', disabled: false },
    // { field: 'Load', header: TRANSLATE('UPS Load (Watts)'), width: '150', class: 'hidden-sm', disabled: false },
    // { field: 'batteryRun', header: TRANSLATE('Remaining Runtime (Mins)'), width: '210', class: 'hidden-sm', disabled: false },
    // { field: 'batteryCapacity', header: TRANSLATE('Battery Capacity'), width: '200', class: 'hidden-sm', disabled: false },
    // { field: 'btyReplacement.BR_Rc_Date', header: TRANSLATE('RBRD'), width: '180', class: 'col-nowrap', disabled: false },
    // { field: '', header: TRANSLATE('Trial Remaining Days'), width: '200', class: '', disabled: false },
    // { field: 'BHI', header: TRANSLATE('BHI'), width: '120', class: '', disabled: false },
    { field: '', header: TRANSLATE('Info'), width: '860', class: 'nowrap', disabled: true },
    { field: 'desc', header: TRANSLATE('Description'), width: '380', class: 'nowrap', disabled: false }
  ];
  deviceTable_cols: any[] = [
    { field: 'status', header: TRANSLATE('Status'), width: '80', class: 'nowrap text-center', disabled: false },
    { field: 'name', header: TRANSLATE('Name'), width: '200', class: '', disabled: false },
    { field: '', header: TRANSLATE(''), width: '180', class: '', disabled: false },
    { field: 'type', header: TRANSLATE('Device Type'), width: '90', class: 'hidden-sm', disabled: false },
    // { field: 'Load', header: TRANSLATE('UPS Load (Watts)'), width: '150', class: 'hidden-sm', disabled: false },
    // { field: 'batteryRun', header: TRANSLATE('Remaining Runtime (Mins)'), width: '210', class: 'hidden-sm', disabled: false },
    // { field: 'batteryCapacity', header: TRANSLATE('Battery Capacity'), width: '200', class: 'hidden-sm', disabled: false },
    // { field: 'btyReplacement.BR_Rc_Date', header: TRANSLATE('RBRD'), width: '180', class: 'col-nowrap', disabled: false },
    // { field: '', header: TRANSLATE('Trial Remaining Days'), width: '200', class: '', disabled: false },
    // { field: 'BHI', header: TRANSLATE('BHI'), width: '120', class: 'hidden-sm', disabled: false },
    { field: 'info', header: TRANSLATE('Info'), width: '860', class: 'hidden-sm', disabled: false },
    { field: 'desc', header: TRANSLATE('Description'), width: '380', class: 'nowrap', disabled: false }
  ];
  loading = true;
  dataLoading = true;
  dataLoadingView = [{}, {}, {}, {}, {}];
  display = false;
  displayConfirmDialog = false;
  powerMaster = isODM;
  isMsp = false;
  UpdateInfoParam = {} as UpdateInfoModel;
  mspRegionFilter;
  region_dic = {};
  SourceType = SourceType;
  private componentDestroyed = new Subject();
  companionAlert = true;
  clickLock : boolean = false;
  selectDevice = [];
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  @ViewChild(EditGroupComponent, { static: false }) child: EditGroupComponent;
  @ViewChild(DeleteGroupComponent, { static: false }) childDel: DeleteGroupComponent;
  constructor(private translateService: TranslateService, private store: Store<fromStore.State>,
    private messageService: MessageService, private preferenceService: PreferenceService,
    private ngxService: NgxUiLoaderService, private router: Router,
    private regionService: RegionService) {

    this.store.select(fromStore.getIsActiveUserModule, PackageList.Companion).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      // const packageCompanion = Boolean(res);
      const packageCompanion = false;
      if (!packageCompanion) {
        this.companionAlert = false;
      }
    });

    // Get Plan Setting Info
    this.store.select(fromStore.getPlanSetting).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.Loading && res.Loaded) {
        if (this.clickLock) {
          let purchasingPlanList = Object.values(res.entities).filter((i) => i.Status !== 2); // no expired.
          purchasingPlanList = purchasingPlanList.map((item) => {
            return { ...item, expirationDate: (item.RemainDay > 0) ? new Date().setDate(new Date().getDate() + item.RemainDay) : 'Expired' };
          });
          const usingPlan = Object.values(purchasingPlanList).find((i) => i.Status === 1);
          if (usingPlan) {
            const dcode_list = [...(Array.isArray(usingPlan.UsingDevices) ? usingPlan.UsingDevices : [])];
            if (this.selectDevice && this.selectDevice.length > 0) {
              this.selectDevice.forEach(i => dcode_list.push(Number(i.dcode)));
            }
            const params: PlanSettingParams = {
              PlanInfoId: parseInt(usingPlan.Id, 10),
              dcodes: dcode_list // convert into number.
            };
            if (params.dcodes.length > usingPlan.NodeTotal) {
              this.childDialog.checkLocked(params, false);
            } else {
              this.childDialog.checkLocked(params, true);
            }
            this.clickLock = false;
          } else {
            this.childDialog.expiredDialog();
          }
        }
      }
    });

    combineLatest(this.store.select(fromStore.getMspRegionFilter), this.store.select(fromStore.getRegionState))
    .pipe(takeUntil(this.componentDestroyed)).subscribe(([filter, region]) => {
      this.mspRegionFilter = null;

      if (region.Loaded && !region.Loading) {
        this.region_dic = {};
        Object.values(region.entities).map(r => {
          this.region_dic[r.Id] = r;
        });
        if (filter !== null) {
          this.isMsp = filter.isMsp;
          if (filter.filterLoaded) {
            this.mspRegionFilter = filter.selectedId;
          }
          if (Object.keys(this.region_dic).length !== 0) {
            this.packageSetting();
          }
        }
      }
    });

    this.regionService.geteventEmitter.pipe(takeUntil(this.componentDestroyed)).subscribe((eventData) => {
      if (eventData === geteventEmitterType.SelectTab) {
        const selectTab = parseInt(this.regionService.GetSelectTab, 10);
        this.packageSetting();
        // if (this.isMsp) {
          if (selectTab === 0) {
            this.deviceGroupList$ = this.deviceGroupList$.pipe(
              map(res => {
                if (res !== undefined) {
                  return res.map((m) => {
                    if (m.children !== undefined) {
                      const filteredChildren = m.children.filter(c => c.data.canTrial == undefined || !c.data.canTrial);
                      return {
                        ...m,
                        data: { ...m.data },
                        children: filteredChildren.length > 0 ? filteredChildren.map(c => ({ ...c, data: { ...c.data } })) : [] as TreeNode[],
                      };
                    }
                    return { ...m, data: { ...m.data } };
                  });
                }
                return [];
              })
            );
          } else if (selectTab === 1) {
            this.deviceGroupList$ = this.deviceGroupList$.pipe(
              map(res => {
                if (res !== undefined) {
                  return res.filter((m) => m.data.type !== groupStr && !m.data.is_shared).map((m) => {
                    if (m.children !== undefined) {
                      const filteredChildren = m.children.filter(c => c.data.canTrial == undefined || !c.data.canTrial);
                      return {
                        ...m,
                        data: { ...m.data },
                        children: filteredChildren.length > 0 ? filteredChildren.map(c => ({ ...c, data: { ...c.data } })) : [] as TreeNode[],
                      };
                    }
                    return { ...m, data: { ...m.data } };
                  });
                }
                return [];
              })
            );
          } else if (selectTab === 2) {
            this.deviceGroupList$ = this.deviceGroupList$.pipe(
              map(res => {
                if (res !== undefined) {
                  return res.filter((m) => m.data.type === groupStr && !m.data.is_shared).map((m) => {
                    const filteredChildren = m.children.filter(c => c.data.canTrial == undefined || !c.data.canTrial);
                    return {
                      ...m,
                      data: { ...m.data },
                      children: filteredChildren.length > 0 ? filteredChildren.map(c => ({ ...c, data: { ...c.data } })) : [] as TreeNode[],
                    };
                  });
                }
                return [];
              })
            );

          } else if (selectTab === 3) {
            this.deviceGroupList$ = this.deviceGroupList$.pipe(
              map(res => {
                if (res !== undefined) {
                  return res.filter((m) => m.data.type !== groupStr && m.data.is_shared);
                }
                return [];
              })
            );

          } else if (selectTab === 4) {
            this.deviceGroupList$ = this.deviceGroupList$.pipe(
              map(res => {
                if (res !== undefined) {
                  return res.filter((m) => m.data.type === groupStr && m.data.is_shared);
                }
                return [];
              })
            );
          }
        // }
      }
    });
  }

  ngOnInit() {
    this.dataLoading = true;
    setTimeout(() => {
      this.dataLoading = false;
    }, 1000);
    this.packageSetting();
  }

  toggle() {
    this.stacked = !this.stacked;
  }

  // onLoad() {
  //   this.loading = false;
  // }

  triggerEdit(data) {
    this.child.editGroup(data);
  }

  triggerDelete(data) {
    this.childDel.deleteGroup(data);
  }

  packageSetting() {
    this.dataLoading = true;
    setTimeout(() => {
      this.dataLoading = false;
    }, 1000);
    this.store.select(fromStore.getIsActiveUserModule, PackageList.Group).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.groupFeature = Boolean(res);
      if (this.groupFeature) {
        this.deviceGroupList$ = this.store.select(fromStore.getGroupDevicesPageListView);
        this.store.select(fromStore.getGroupDevicesPageListView).subscribe(res => {
        this.deviceGroupList = res.map(n => ({
          ...n,
          data: n.data ? { ...n.data } : n.data,
          children: (n.children || []).map(c => ({
            ...c,
            data: c.data ? { ...c.data } : c.data,
          })),
        }));
        this.deviceGroupListStash = this.deviceGroupList.map(n => ({
          ...n,
          data: n.data ? { ...n.data } : n.data,
          children: (n.children || []).map(c => ({
            ...c,
            data: c.data ? { ...c.data } : c.data,
          })),
        }));
          this.searchKeyWord();
        });
      } else {
        this.deviceList$ = this.store.select(fromStore.getWithoutGroupFeatureListView);
      }
    });
  }

  customSort(event: SortEvent) {
    // NgRx 9 不可變性: 創建數組副本再排序，然後賦值回 event.data
    event.data = [...event.data].sort((data1, data2) => {
      const value1 = data1[event.field];
      const value2 = data2[event.field];
      let result = null;
      if (value1 == null && value2 != null) {
        result = -1;
      } else if (value1 != null && value2 == null) {
        result = 1;
      } else if (value1 == null && value2 == null) {
        result = 0;
      } else if (typeof value1 === 'string' && typeof value2 === 'string') {
        result = value1.localeCompare(value2);
      } else {
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;
      }
      return (event.order * result);
    });
  }

  displayExpiredDialog(rowData) {
    if (!this.isMsp) {
      this.clickLock = true;
      this.selectDevice = []
      this.selectDevice.push(rowData);
      this.store.dispatch(new fromMyfeatures.GetPlanSettings());
      // this.childDialog.expiredDialog(rowData);
    }
  }

  displayisTrialDialog(rowData) {
    this.childDialog.isTrialDialog(rowData);
  }

  rejectShareDevice(rowData) {
    this.objectSharingParam = {
      ...this.objectSharingParam,
      share_id: rowData.share_id,
      owner_acode: rowData.owner_acode,
      is_confirm: false,
    };
    this.store.dispatch(new fromMyfeatures.UpdateDeviceSharing({ ...this.objectSharingParam }));
  }

  acceptShareDvice(rowData) {
    this.objectSharingParam = {
      ...this.objectSharingParam,
      share_id: rowData.share_id,
      owner_acode: rowData.owner_acode,
      is_confirm: true,
    };
    this.store.dispatch(new fromMyfeatures.UpdateDeviceSharing({ ...this.objectSharingParam }));
  }

  rejectSharedGroup(rowData) {
    this.objectSharingParam = {
      ...this.objectSharingParam,
      share_id: rowData.share_id,
      owner_acode: rowData.owner_acode,
      is_confirm: false,
    };
    this.store.dispatch(new fromMyfeatures.UpdateGroupSharing({ ...this.objectSharingParam }));
  }

  acceptSharedGroup(rowData) {
    this.objectSharingParam = {
      ...this.objectSharingParam,
      share_id: rowData.share_id,
      owner_acode: rowData.owner_acode,
      is_confirm: true,
    };
    this.store.dispatch(new fromMyfeatures.UpdateGroupSharing({ ...this.objectSharingParam }));
  }

  routerCompanion() {
    this.router.navigate(['/companion']);
  }

  onPageloading(event) {
    this.dataLoading = true;
    setTimeout(() => {
      this.dataLoading = false;
    }, 1000);
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  ngOnChanges() {
    this.searchKeyWord();
  }

  searchKeyWord() {
    if (this.selectedTab === 0) {
      const matchingGroups = [];
      this.deviceGroupListStash.map((m) => {
        if (m !== undefined) {
          if (m.children !== undefined) {
            const filteredChildren = m.children.filter(c => c.data.canTrial === undefined || !c.data.canTrial);
            if (filteredChildren.length > 0) {
              matchingGroups.push(m);
            }
          } else {
            matchingGroups.push(m);
          }
        }
      });
      this.sortListView(matchingGroups);
      if (!this.keyWord) {
      } else {
        const matchingGroups = [];
        this.deviceGroupListStash.map((m) => {
          if (m !== undefined) {
            if (m.children !== undefined) {
              const device = [];
              m.children.map((c) => {
                if (c.data.canTrial == undefined || !c.data.canTrial) {
                  device.push(c);
                }
              });
              const filteredChildren = device.filter(c => c.data && c.data.name && c.data.name.toLowerCase().includes(this.keyWord.toLowerCase()));
              if (filteredChildren.length > 0) {
                matchingGroups.push({ data: m.data, children: filteredChildren });
              } else {
                matchingGroups.push({ data: m.data, children: [{data: {}}]});
              }
            } else {
              if (m.data.name.toLowerCase().includes(this.keyWord.toLowerCase())) {
                matchingGroups.push(m);
              }
            }
          }
        });
        this.sortListView(matchingGroups);
      }
    } else if (this.selectedTab === 1) {
      const matchingGroups = [];
      this.deviceGroupListStash.map((m) => {
        if (m !== undefined) {
          if (m.data.type !== groupStr && !m.data.is_shared) {
            if (m.children !== undefined) {
              const filteredChildren = m.children.filter(c => c.data.canTrial == undefined || !c.data.canTrial);
              if (filteredChildren.length > 0) {
                matchingGroups.push(m);
              }
            } else {
              matchingGroups.push(m);
            }
          }
        }
      });
      this.sortListView(matchingGroups);
      if (!this.keyWord) {
      } else {
        const matchingGroups = [];
        this.deviceGroupListStash.map((m) => {
        if (m !== undefined) {
          if (m.data.type !== groupStr && !m.data.is_shared && m.data.name && m.data.name.toLowerCase().includes(this.keyWord.toLowerCase())) {
            if (m.children !== undefined) {
              const filteredChildren = m.children.filter(c => c.data.canTrial == undefined || !c.data.canTrial);
              if (filteredChildren.length > 0) {
                matchingGroups.push(m);
              }
            } else {
              matchingGroups.push(m);
            }
          }
        }
        });
        this.sortListView(matchingGroups);
      }
    } else if (this.selectedTab === 2) {
      const matchingGroups = [];
      this.deviceGroupListStash.map((m) => {
        if (m !== undefined) {
          if (m.data.type === groupStr && !m.data.is_shared) {
            if (m.children !== undefined) {
              const filteredChildren = m.children.filter(c => c.data.canTrial == undefined || !c.data.canTrial);
              if (filteredChildren.length > 0) {
                matchingGroups.push(m);
              }
            }
          }
        }
      });
      this.sortListView(matchingGroups);
      if (!this.keyWord) {
      } else {
        const matchingGroups = [];
        this.deviceGroupListStash.map((m) => {
          if (m !== undefined) {
            if (m.data.type === groupStr && !m.data.is_shared) {
              if (m.children !== undefined) {
                const device = [];
                m.children.map((c) => {
                  if (c.data.canTrial == undefined || !c.data.canTrial) {
                    device.push(c);
                  }
                });
                const filteredChildren = device.filter(c => c.data && c.data.name && c.data.name.toLowerCase().includes(this.keyWord.toLowerCase()));
                if (filteredChildren.length > 0) {
                  matchingGroups.push({ data: m.data, children: filteredChildren });
                } else {
                  matchingGroups.push({ data: m.data, children: [{data: {}}]});
                }
              }
            }
          }
        });
        this.sortListView(matchingGroups);
      }
    } else if (this.selectedTab === 3) {
      const matchingGroups = [];
      this.deviceGroupListStash.map((m) => {
        if (m !== undefined) {
          if (m.data.type !== groupStr && m.data.is_shared) {
            matchingGroups.push(m);
          }
        }
      });
      this.sortListView(matchingGroups);
      if (!this.keyWord) {
      } else {
        const matchingGroups = [];
        this.deviceGroupListStash.map((m) => {
          if (m !== undefined) {
            if (m.data.type !== groupStr && m.data.is_shared && m.data.name && m.data.name.toLowerCase().includes(this.keyWord.toLowerCase())) {
              matchingGroups.push(m);
            }
          }
        });
        this.sortListView(matchingGroups);
      }
    } else if (this.selectedTab === 4) {
      const matchingGroups = [];
      this.deviceGroupListStash.map((m) => {
        if (m.data.type === groupStr && m.data.is_shared) {
          matchingGroups.push(m);
        }
      });
      this.sortListView(matchingGroups);
      if (!this.keyWord) {
      } else {
        const matchingGroups = [];
        this.deviceGroupListStash.map((m) => {
          if (m.data.type === groupStr && m.data.is_shared) {
            if (m.children !== undefined) {
              const device = [];
              m.children.map((c) => {
                if (c.data.canTrial == undefined || !c.data.canTrial) {
                  device.push(c);
                }
              });
              const filteredChildren = device.filter(c => c.data && c.data.name && c.data.name.toLowerCase().includes(this.keyWord.toLowerCase()));
              if (filteredChildren.length > 0) {
                matchingGroups.push({ data: m.data, children: filteredChildren });
              } else {
                matchingGroups.push({ data: m.data, children: [{data: {}}]});
              }
            }
          }
        });
        this.sortListView(matchingGroups);
      }
    }
  }

  sortListView(matchingGroups) {
    const sortFunction = (a: any, b: any) => {
      const value1 = a.name;
      const value2 = b.name;
      return this.sortType ? value1.localeCompare(value2, undefined, { numeric: true })
                         : value2.localeCompare(value1, undefined, { numeric: true });
    };
    const groups = matchingGroups.filter(item => item.data.type === 'Group')
      .sort((a: any, b: any) => sortFunction(a.data, b.data))
      .map((obj) => { const childrenData = [...(obj.children || [])].sort((a: any, b: any) => sortFunction(a.data, b.data));
      return { data: obj.data, children: childrenData };
    });

    const devices = matchingGroups.filter(item => item.data.type !== 'Group')
      .sort((a: any, b: any) => sortFunction(a.data, b.data));
    this.resetTable();
    this.deviceGroupList = [...groups, ...devices];
  }

  resetTable() {
    if (this.tt !== undefined) {
      this.tt.reset();
    }
  }

}
